const NotesTypes = {
    TT_Notes_ACTION_START:"TT_Notes_ACTION_START",
    TT_Notes_FETCH_DATA:"TT_Notes_FETCH_DATA",
    TT_Notes_FETCH_DATA_FAILED:"TT_Notes_FETCH_DATA_FAILED",
    TT_Notes_ADD_DATA:"TT_Notes_ADD_DATA",
    TT_Notes_SOCKET_UPDATE_DATA:"TT_Notes_SOCKET_UPDATE_DATA",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    project: {},
    set_payload: ""
}

const TempTabNotesReducer = (state=Initial_state, action) => {
    switch(action.type){
        case NotesTypes.TT_Notes_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case NotesTypes.TT_Notes_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                project: action.payload.project,
                set_payload: action.payload.set_payload
            }

        case NotesTypes.TT_Notes_SOCKET_UPDATE_DATA:
            const { data, set_payload } = action.payload;
            if(state.set_payload !== set_payload){
                return {
                    ...state
                }
            }
            return {
                ...state,
                response: data
            }

        case NotesTypes.TT_Notes_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error_message: action.payload
            }

        default:
            return state;
    }
};

export default TempTabNotesReducer;